import { Box, Button, Typography } from '@mui/material';

import { FilterAlt } from '@mui/icons-material';
import ClearIcon from '@mui/icons-material/Clear';
import { useFiltersCard } from './hooks';
import { Select } from 'ui';
import { t } from 'i18next';
import { theme } from '@store';
import { USStateSelect } from '@components';

export const FiltersCard = () => {
  const {
    handleToggleFiltersCard,
    filters,
    resetFilters,
    handleApply,
    isResetDisabled,
    isApplyDisabled,
    handleChangeOperatorFilter,
    handleChangePartnerFilter,
    handleChangeStateFilter,
    operatorShortOptions,
    partnerShortOptions,
  } = useFiltersCard();

  return (
    <Box
      sx={{
        minWidth: '260px',
        maxWidth: '260px',
        boxShadow: 'initial',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          padding: '0',
          pt: '1rem',
          pb: '0.5rem',
          mb: '0.5rem',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <FilterAlt />
          <Typography variant='subtitle1'>Filters</Typography>
        </Box>
        <Box
          onClick={handleToggleFiltersCard}
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            ':hover': {
              cursor: 'pointer',
              bgcolor: theme => theme.palette.grey[50],
              borderRadius: '6px',
            },
            height: '30px',
            width: '30px',
          }}
        >
          <ClearIcon />
        </Box>
      </Box>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          maxHeight: `calc(100vh - 465px)`,
          overflowY: 'auto',
          [theme.breakpoints.down('md')]: {
            maxHeight: 'calc(100vh - 310px)',
          },
          pt: 1,
        }}
      >
        <Select
          sx={{
            backgroundColor: theme => theme.palette.common.white,
          }}
          name='team'
          label='Partner'
          value={filters.partner_id}
          onChange={handleChangePartnerFilter}
          size='medium'
          options={partnerShortOptions}
          clearLabel='All'
          clearable
        />

        <Select
          sx={{
            backgroundColor: theme => theme.palette.common.white,
          }}
          name='operator'
          label='Operator'
          value={filters.operator_id}
          onChange={handleChangeOperatorFilter}
          size='medium'
          options={operatorShortOptions}
          clearLabel='All'
          clearable
        />

        <USStateSelect
          sx={{
            backgroundColor: theme => theme.palette.common.white,
          }}
          name='state'
          value={filters.state}
          onChange={handleChangeStateFilter}
          clearLabel='All'
          clearable
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          gap: '0.5rem',
          width: '100%',
          py: '1rem',
        }}
      >
        <Button
          variant='outlined'
          onClick={resetFilters}
          sx={{ width: '100%', maxHeight: '2rem' }}
          disabled={isResetDisabled}
        >
          {t('general.reset')}
        </Button>
        <Button
          onClick={handleApply}
          variant='contained'
          color='secondary'
          loadingPosition='center'
          sx={{
            color: 'white',
            width: '100%',
            maxHeight: '2rem',
          }}
          disabled={isApplyDisabled}
        >
          {t('general.apply')}
        </Button>
      </Box>
    </Box>
  );
};
